import BaseSetup from '@/components/BaseSetup';

export type SharedAddButtonEmits = {};
export type SharedAddButtonProps = {};

export default class SharedAddButtonSetup extends BaseSetup {

	static readonly defaultProps = {};

	constructor (
		private props: SharedAddButtonProps,
		private emits: SharedAddButtonEmits,
	) {
		super();
	}

}
